<template>
  <lm-help-tip
    link="https://landscapemonitor.io/platform/faq#roles"
    link-text="Visit the FAQ for detailed info about roles"
    class="ColumnRoleHelp"
  >
    TYPES OF ROLES<br />
    <span class="ColumnRoleHelp-highlight">Account Owner</span>: The person who
    created the Landscape. Full privileges.<br />
    <span class="ColumnRoleHelp-highlight">Admin</span>: Full administrator
    rights for the Landscape, but cannot delete it.<br />
    <span class="ColumnRoleHelp-highlight">Manager</span>: Can manage the map
    but can not manage users. Can be 'scoped' to define in detail which actors
    they are responsible for.<br />
    <span class="ColumnRoleHelp-highlight">Member</span>: Can access the
    Landscape but they can not modify the map.<br /><br />
  </lm-help-tip>
</template>

<script>
import LmHelpTip from '@/components/ui/LmHelpTip'
export default {
  name: 'ColumnRoleHelp',
  components: {LmHelpTip}
}
</script>

<style>
.ColumnRoleHelp i {
  font-size: 21px;
}
.ColumnRoleHelp-highlight {
  /* Global specificity needed */
  font-weight: 500;
}
</style>
